import React, { useEffect, useState } from 'react'
import "./SavedAddress.css";
import { Button, Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate } from 'react-router-dom';
import { faTrashAlt } from '@fortawesome/free-regular-svg-icons';
import Pink_Btn from '../../common/common_btn/pink_btn/Pink_Btn';
import { useDispatch, useSelector } from 'react-redux';
import { deleteAddress, getAllOrderAddress } from '../../../features/order/orderSlice';
import Altert_Modal from '../../common/common_modal/alert_modal/Altert_Modal';


const SavedAddress = ({ addressId, setAddressId, orderAddress, setOrderAddress }) => {

    const navigate = useNavigate()

    const [show, setShow] = useState(false);

    const renderTooltip = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            DELETE ADDRESS
        </Tooltip>
    );

    const dispatch = useDispatch();
    const allAddress = useSelector((state) => state.order.allOrdersAddress);

    useEffect(() => {
        dispatch(getAllOrderAddress());
    }, [dispatch]);

    // FIX 3: Renamed top-level variable to avoid shadowing the .map() callback parameter
    const selectedAddress = orderAddress || allAddress?.data?.[0];

    const handleDelete = async (id) => {
        const res = await dispatch(deleteAddress(id));
        if (res.meta?.requestStatus === "fulfilled") {
            await dispatch(getAllOrderAddress());
        } else if (res.meta?.requestStatus === "rejected") {
            // handle error if needed
        }
    };

    return (
        <section className="SavedAddress">
            <div className='container'>

                <div className='add_new_address_div'>
                    <div className='address_title_div'>
                        <div className='heading_div'>
                            <p>Saved Address</p>
                        </div>
                        <div className='btn_holder'>
                            <Button className="add_new-btn" type="button"
                                onClick={() => { navigate(`/add-new-address?addressID=${null}`) }}
                            >
                                Add New
                            </Button>
                        </div>
                    </div>
                </div>

                <div className='saved_address_main_div'>
                    <div className='addres_card_holder'>
                        <div className="row">
                            {allAddress?.daxta && allAddress?.data?.length > 0 ? (
                                allAddress?.data?.map((address) => {

                                    const formattedAddress = [
                                        address?.building,
                                        address?.floor,
                                        address?.apartment,
                                        address?.street,
                                        address?.direction,
                                        address?.Users_Address_Detail?.City?.name,
                                        address?.Users_Address_Detail?.State?.name,
                                        address?.Users_Address_Detail?.Country?.name,
                                        address?.Users_Address_Detail?.Pincode?.name,
                                    ]
                                        .filter(Boolean)
                                        .join(", ");

                                    return (
                                        <div className="col-lg-6 col-md-6 col-sm-12 col-12" key={address?.id}>
                                            <div className="address_card">
                                                <div className="top_address_heading">
                                                    <div className="heading">
                                                        <p>{address?.Address_Type?.name || ""}</p>
                                                    </div>

                                                    <div
                                                        className="form-holder"
                                                        onClick={() => {
                                                            setOrderAddress(address);
                                                            setAddressId(address?.id);
                                                        }}
                                                    >
                                                        {/* FIX 4: Added onChange handler to avoid React controlled input warning */}
                                                        <Form.Check
                                                            type="radio"
                                                            id={address?.id}
                                                            checked={addressId === address?.id}
                                                            onChange={() => {
                                                                setOrderAddress(address);
                                                                setAddressId(address?.id);
                                                            }}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="user_address">
                                                    <p className="user_name">
                                                        {address?.first_name || address?.User?.name || "Unknown"}
                                                    </p>

                                                    <p className="contact_no">
                                                        {address?.contact_no || address?.User?.contact_no || "Unknown"}
                                                    </p>

                                                    <div className="footer_div">
                                                        <div className="address_div">
                                                            <p>{formattedAddress || "No Address Found"}</p>
                                                        </div>

                                                        <div
                                                            className="edit_btn_div"
                                                            onClick={() =>
                                                                navigate(`/add-new-address?addressID=${address?.id}`)
                                                            }
                                                        >
                                                            <p>Edit</p>
                                                        </div>

                                                        <div
                                                            className="delete_icon_holder"
                                                            onClick={() => handleDelete(address?.id)}
                                                        >
                                                            <OverlayTrigger
                                                                placement="right"
                                                                delay={{ show: 250, hide: 400 }}
                                                                overlay={renderTooltip}
                                                            >
                                                                <FontAwesomeIcon icon={faTrashAlt} className="delete_icon" />
                                                            </OverlayTrigger>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })
                            ) : (
                                <div className="text-center">
                                    <p>No Address Found</p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                {allAddress?.dsata && allAddress?.data?.length > 0 && (


                    <div className="text-center btn_holder">
                        <div className="">
                            <Pink_Btn btnText={'Proceed with Saved Address'} onClick={() => {
                                if (addressId) {
                                    navigate("/checkout");
                                } else {
                                    setShow(true); // Show alert modal if no address is selected
                                }
                            }} />
                        </div>
                    </div>
                )}


                <Altert_Modal
                    show={show}
                    onHide={() => setShow(false)}
                    successText="Please select an address before proceeding."
                    btnname="Ok"
                />

            </div>
        </section>
    )
}

export default SavedAddress